import { enableDisplay, enableInclude, enableIncludeEntity  } from 'core/handlers/DisplayHandler'
import { ReelsManager } from 'managers/ReelsManager'
import { gameStorage } from 'services/ElementsStorageService'
import { addEntity } from 'utils/AssetParser'
import { Context } from 'utils/Context'
import { Device } from 'utils/Device'
import { Language } from 'utils/Language'
import { log } from 'utils/Logger'
import { noop } from 'utils/Mocks'

import Core from './index'

function toEntities(data) {
  const entity = new MakeViewEntity(data)
  if (data.properties?.include) {
    enableIncludeEntity(entity, data)
  }
  else {
    enableDisplay(entity, data)
  }

  const register = entity.register || noop
  const objects = data.objects
    .filter(Device.validate)
    .filter(Context.validate)
    .filter(Language.validate)
    .map(toObject)

  ReelsManager.getReelsName(entity.name)
  gameStorage.setEntities(entity, entity.name)

  function toObject(data) {

    const object = makeViewObject(data)
    gameStorage.set(object, data.name)
    register(data.type, object, data)

    if (data.includeObj) {
      enableInclude(entity, data)
      object.data = data
    }
    else{
      enableDisplay(object, data)
    }

    return object
  }

  entity.addChild(...objects)

  entity.mask = objects.find((x) => x.name === 'mask')
  if (data.properties?.include) {

    addEntity(entity)

    return new PIXI.Container()
  }
  else {

    enableDisplay(entity, data)
    return entity
  }

}

function MakeViewEntity(data) {
  const constructor = Core.entity[data.name]
  if (constructor) {
    return new constructor(data)
  }

  return new Core.display.Container
}

function makeViewObject(data) {
  const coreTypes = ['text', 'buttons', 'win', 'display', 'buttons']

  for (const type of coreTypes) {
    const constructor = Core[type][data.type]
    if (constructor) {
      return new constructor(data)
    }
  }

  if (data.type === 'BonusTwoAnimation') {
    return makeBonusTwoAnimation(data)
  }

  log(`WARNING! NO FACTORY FUNCTION FOR: ${data.type}`, 'WARNING')
  return Core.display.Container()
}

function makeBonusTwoAnimation(data){
  const self = Core.display.Container()
  self.addChild(Core.display.BonusTwoAnimation(data))
  return self
}

export function buildLayout(layers) {
  return layers.map(toEntities)
}
